<template>
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 9 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M0.826902 16.8267L7.41276 10.2408C8.19054 9.46302 8.19054 8.1903 7.41276 7.41252L0.826902 0.82666"
            stroke="currentColor"
            stroke-width="1.65289"
            stroke-miterlimit="10"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
